import { Component } from '@angular/core';
import { StockPage } from './stock/stock';
import { OutputPage } from './output/output';
import { MovementsPage } from './movements/movements';

/**
 * Generated class for the InventoryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-inventory',
  template: `
  <ion-tabs class="tabs-icon" [color]="'primary'">
    <ion-tab tabTitle="Salidas" tabIcon="open" [root]="tab3"></ion-tab>
    <ion-tab tabTitle="Stock" tabIcon="basket" [root]="tab1"> </ion-tab>
    <ion-tab tabTitle="Movimientos" tabIcon="ios-clipboard-outline" [root]="tab2"></ion-tab>
  </ion-tabs>
`,
})
export class InventoryPage {
  tab1;
  tab2;
  tab3;
  constructor() {
    this.tab1 = StockPage;
    this.tab2 = MovementsPage;
    this.tab3 = OutputPage;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InventoryPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/inventory/inventory.ts